import React from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function CargarExcelPropuesta() {
  const navigate = useNavigate();

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const XLSX = require("xlsx");
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        let rows = XLSX.utils.sheet_to_json(sheet);

        // Normalizar nombres de columnas
        const normalize = (str) =>
          str
            ? str
                .toString()
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "")
                .replace(/[áéíóúñ]/g, (m) => ({ á: "a", é: "e", í: "i", ó: "o", ú: "u", ñ: "n" }[m]))
            : "";

        rows = rows.map((row) => {
          const out = {};
          Object.keys(row).forEach((key) => {
            const nKey = normalize(key);
            if (nKey === "año" || nKey === "ano") out["ano"] = row[key];
            else if (key.trim().toLowerCase() === "porcentaje de cobro" || (nKey.includes("porcentaje") && nKey.includes("cobro")))
              out["porcentajeCobro"] = row[key];
            else if (nKey === "mes") out["mes"] = row[key];
            else if (nKey === "horas") out["horas"] = row[key];
            else if (nKey === "monto") out["monto"] = row[key];
            else if (nKey === "iva") out["iva"] = row[key];
            else if (nKey === "total") out["total"] = row[key];
            else if (nKey === "observaciones") out["observaciones"] = row[key];
          });
          return out;
        });

        // Validar mínimos (mes, año, horas, monto). IVA/Total se calculan luego si faltan.
        let errores = "";
        rows.forEach((row, idx) => {
          ["mes", "ano", "horas", "monto"].forEach((f) => {
            if (row[f] === undefined || row[f] === "") {
              errores += `Fila ${idx + 2}: Falta el dato en la columna "${f}".\n`;
            }
          });
        });

        if (errores) {
          toast.error("Error en el archivo Excel:\n" + errores, { autoClose: 6000 });
          return;
        }

        localStorage.setItem("desgloseExcel", JSON.stringify(rows));
        toast.success("Archivo Excel cargado correctamente.", { autoClose: 2000 });
        navigate(-1);
      } catch (err) {
        toast.error("Error al cargar el archivo Excel.", { autoClose: 3000 });
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <motion.div className="container my-5" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      <h2 className="mb-4 text-primary">Cargar Excel de Propuesta</h2>
      <input className="form-control mb-3" type="file" accept=".xlsx,.xls" onChange={handleFile} />
      <button className="btn btn-secondary" onClick={() => navigate(-1)}>
        Volver
      </button>
    </motion.div>
  );
}
